import client from "@/src/apollo/client";
import GenericHead from "@/src/components/Head/GenericHead";
import ContributorHeader from "@/src/components/Header/contributors";
import LoadMoreContainer from "@/src/components/LoadMoreContainer";
import FlagContainer from "@/src/components/blocks/FlagContainer";
import {
  GET_SINGLE_CONTRIBUTOR_POSTS_PAGINATED,
  GetContributorBySlug,
} from "@/src/gql/queries/contributors";

import { ArticleCardType, ContributorType, NavData } from "@/src/types";
import { GetStaticProps } from "next";

export interface SingleContributorData extends ContributorType {
  posts: { nodes: ArticleCardType[] };
}

export interface SingleContributorProps {
  contributor: SingleContributorData;
}

const SingleContributor = ({ contributor }: SingleContributorProps) => {
  const posts = contributor?.posts?.nodes || [];
  const flagArticles = posts?.slice(0, 3);
  const flagArticleContainer = flagArticles?.map(function (article, index) {
    return {
      position: index === 0 ? 0 : index === 1 ? 1 : 2,
      article: { heroArticlePostItem: { nodes: [article] } },
    };
  });

  return (
    <>
      <GenericHead title={`SCPB Contributor - ${contributor.name}`} />

      <div>
        <div className="mx-auto flex flex-col gap-4">
          {
            // @ts-ignore
            <FlagContainer flags={flagArticleContainer} />
          }
        </div>

        <ContributorHeader contributor={contributor} />

        <div className="w-[100%] bg-white">
          <div className="container mx-auto flex flex-col gap-4 py-4">
            <LoadMoreContainer
              loadMoreQuery={GET_SINGLE_CONTRIBUTOR_POSTS_PAGINATED}
              initialArticles={posts?.slice(3)}
              ignoreIds={flagArticles?.map(function (article) {
                return article.id;
              })}
              loadMoreVariables={{ id: contributor?.uri }}
              convertPayload={(object: any) => {
                const cursor =
                  object?.contributor?.posts?.edges?.length > 0
                    ? object?.contributor?.posts?.edges[
                        object?.contributor?.posts?.edges.length - 1
                      ].cursor
                    : "";
                return {
                  posts: object?.contributor?.posts?.edges.map(function (
                    article: any
                  ) {
                    return article.node;
                  }),
                  thelastCursor: cursor,
                };
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const contributor = await client.query({
    query: GetContributorBySlug,
    variables: { id: `/contributors/${context.params?.slug}` },
  });

  if (!contributor) {
    return {
      props: { contributor },
      notFound: true,
    };
  }

  const uri = contributor?.data?.asd || "";
  return { props: { contributor: contributor?.data?.contributor, uri } };
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export default SingleContributor;
